import React from "react";
import "./Banner.css";

import axios from "../../network/api";
import { useState, useEffect } from "react";
import { baseUrl } from "../../network/Constants";
import Carousel from "react-bootstrap/Carousel";
import { Spinner } from "react-bootstrap";

function Banner() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBanner();
  }, []);

  const fetchBanner = (props) => {
    setLoading(true)
    axios
      .get(baseUrl + "/app/banner/")
      .then(async (response) => {
        setBanners(response.data);
        setLoading(false)
      })
      .catch((error) => {
        console.log(error);
        setLoading(false)   
      });
  };

  return (
    <>
     { loading ?  <div className="loader"><Spinner className="loading-color"/></div>: <Carousel interval={3000}>
          {banners &&
            banners
              .map((item, index) => {
                return (
                  <Carousel.Item key={index}>
                    <img
                      className="d-block w-100 banner-img"
                      src={item.banner_image}
                      alt="First slide"
                      data-aos="fade-down"
                      data-aos-easing="linear"
                      data-aos-duration="1500"
                    />
                    {/* <div className="carousel-caption">
                    MBBS Calicut Medical College
                    <br />
                    Batch 1972
                  </div> */}
                  </Carousel.Item>
                );
              })}
        </Carousel> }
   
    </>
  );
}

export default Banner;
